
export default {
  name: "Loader",
  props: {
    loading: Boolean,
  },
}
